import {Member} from "../member/member";

export class Board {

}

export class CommunityBoardPage {
  content: CommunityBoard[];
  totalPages: number;
  totalElements: number;
  number: number;
  size: number;
}

export class EventBoard extends Board {
  id: number;
  createdDate: string;
  author: Member;
  title: string;
  thumbnail: string;
  content: string;
  status: string;
  date: string;
  endDate: string;
  excerpt: string;
  countOfLikes: number;
  countOfComments: number;
  likeByMe: boolean;
}

export class EventBoardPage {
  content: EventBoard[];
  totalPages: number;
  totalElements: number;
  number: number;
  size: number;
}

export class FreeBoard extends Board {
  id: number;
  createdDate: string;
  author: Member;
  title: string;
  thumbnail: string;
  content: string;
  excerpt: string;
  subject: string;
  countOfLikes: number;
  countOfComments: number;
  likeByMe: boolean;
}

export class FreeBoardPage {
  content: FreeBoard[];
  totalPages: number;
  totalElements: number;
  number: number;
  size: number;
}

export class Comment {
  id: number;
  content: string;
  image: string;
  countOfLikes: number;
  member: Member;
  createdDate: string;
  likeByMe: boolean;
  comment: any[];
  showReplyComment?: boolean;
}


export class HelpBoardPage {
  content: HelpBoard[];
  totalPages: number;
  totalElements: number;
  number: number;
  size: number;
}



export class Keywords {
  keywords: string[];
}

export class Categories {
  categories: string[];
}

export class HeyBoard {
  id?: number;
  title: string;
  thumbnail: string;
  location?: any;
  locationName?: string;
  content: string;
  status: string;
  tags : string[];
  author?: Member;
  likeByMe: boolean;
  countOfLikes: number;
  createdDate: string;

  openShare?: boolean;
  url?: string;
  prefix?: string;
}

export class CommunityBoard extends Board {
  id?: number;
  location?: any;
  locationName?: string;
  title: string;
  thumbnail: string;
  content: string;
  tags: string[];
  status: string;
  startDate : string;
  endDate : string;
  category : string;
  url: string;
  summary: string;
  createdDate?: string;
  author?: Member;
  countOfLikes?: number;
  countOfComments?: number;
  likeByMe?: boolean;
  view?: number;

  openShare?: boolean;
  active?: boolean;
}

export class HelpBoard extends Board {
  id?: number;
  createdDate: string;
  author: Member;
  location?: any;
  locationName: string;
  visible: string;
  title: string;
  content: string;
  notice: boolean;
  status: string;
}


export class CommentPost {
  content: string;
  image: string;
}



// WEBPACK FOOTER //
// ./src/app/service/board/board.ts